import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { first, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { SelectedCustomerService } from '../selected-customer/selected-customer.service';
import { GungFlowService } from '../gung-flow/gung-flow.service';

/**
 * Resolves which configurator options are FORCED (auto-selected and locked) for the currently selected customer
 * and flow. Backed by the customer-module ProductConfigurationForcedOptionResolvers on the server. When no
 * resolver is registered the server returns an empty set, so the configurator behaves as before.
 */
@Injectable({
  providedIn: 'root'
})
export class ProductConfigurationForcedOptionService {
  protected http = inject(HttpClient);
  protected selectedCustomerService = inject(SelectedCustomerService);
  protected gungFlowService = inject(GungFlowService);

  fetchForcedOptionIds(optionIds: string[]): Observable<Set<string>> {
    if (!optionIds || optionIds.length === 0) {
      return of(new Set<string>());
    }

    return forkJoin([
      this.selectedCustomerService.getSelectedCustomer().pipe(first()),
      this.gungFlowService.getSelectedFlow().pipe(first())
    ]).pipe(
      switchMap(([customer, flow]) =>
        this.http.post<string[]>('json/product-configuration/forced-options', {
          optionIds,
          customerId: customer?.id,
          flowId: flow?.id
        })
      ),
      map(ids => new Set<string>(ids || []))
    );
  }
}
